// ============================================================================
// page-init.js — replaces the per-page inline <script> bootstrap.
// ----------------------------------------------------------------------------
// Reads the page identifier from `data-page` on <html> and dispatches to
// the right initializer chain. Existing inline init blocks (and their
// `unsafe-inline` CSP cost) all move here.
// ============================================================================

(function () {
    // ── data-bg applier ────────────────────────────────────────────────────
    // Background colour values that vary per-element (polaroid pin/tape
    // colours, placeholder backgrounds) used to live in inline style=""
    // attributes. The strict CSP forbids those, so the HTML now carries
    // `data-bg="#color"` and this function sweeps them, setting the colour
    // via the IDL `element.style.backgroundColor` setter — which CSP
    // does NOT treat as inline.
    //
    // A MutationObserver picks up nodes injected later by template-loader
    // and polaroid-hero (mega menu, footer, polaroid pile, etc.).
    function applyDataBg(root) {
        if (!root || root.nodeType !== 1) return;
        if (root.hasAttribute('data-bg')) {
            root.style.backgroundColor = root.getAttribute('data-bg');
        }
        if (root.querySelectorAll) {
            root.querySelectorAll('[data-bg]').forEach(function (el) {
                el.style.backgroundColor = el.getAttribute('data-bg');
            });
        }
    }

    function watchForDataBg() {
        applyDataBg(document.body);
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                m.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) applyDataBg(node);
                });
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    function pageInit() {
        watchForDataBg();
        var page = document.documentElement.getAttribute('data-page') || '';

        // initTemplates is provided by template-loader.js; it returns a Promise.
        if (typeof initTemplates !== 'function') return;

        initTemplates(page).then(function () {
            switch (page) {
                case 'home':
                    if (typeof initPolaroidHero === 'function') initPolaroidHero();
                    if (typeof initSplitHero === 'function') initSplitHero();
                    if (typeof initAdsSection === 'function') initAdsSection();
                    break;
                case 'ar-experience':
                    if (typeof initThemeToggleAfterTemplates === 'function') {
                        initThemeToggleAfterTemplates();
                    }
                    // AR session analytics: log when a model-viewer enters AR.
                    document.querySelectorAll('model-viewer').forEach(function (viewer) {
                        viewer.addEventListener('ar-status', function (event) {
                            if (event.detail && event.detail.status === 'session-started') {
                                console.log('AR session started for:', event.target.getAttribute('alt'));
                            }
                        });
                    });
                    break;
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', pageInit);
    } else {
        pageInit();
    }
})();
